{
  "about.blocks": "Модерациялана торган серверлар",
  "about.contact": "Бәйләнеш:",
  "about.default_locale": "Килешү буенча",
  "about.disclaimer": "Mastodon-бушлай ачык чыганак программасы һәм Mastodon gmbh сәүдә маркасы.",
  "about.domain_blocks.no_reason_available": "Сәбәбе юк",
  "about.domain_blocks.preamble": "Mastodon гадәттә сезгә бүтән fediverse серверыннан эчтәлекне карарга һәм аның белән кулланучылар белән аралашырга мөмкинлек бирә. Бу конкрет серверда ясалган искәрмәләр.",
  "about.domain_blocks.silenced.explanation": "Гадәттә, сез бу серверның профильләрен һәм эчтәлеген күрмәячәксез, әгәр сез аларны ачыктан-ачык карамасагыз яки бу адымнарны үтәп язылмасагыз.",
  "about.domain_blocks.silenced.title": "Чикле",
  "about.domain_blocks.suspended.explanation": "Бу серверның бернинди мәгълүматлары да эшкәртелмәячәк, сакланмаячак яки алмаштырылмаячак, бу сервердан кулланучылар белән үзара бәйләнешне яки аралашуны мөмкин итми.",
  "about.domain_blocks.suspended.title": "Блокланган",
  "about.language_label": "Тел",
  "about.not_available": "Бу серверда бу мәгълүмат юк иде.",
  "about.powered_by": "{mastodon} нигезендә үзәкчелеге бетерелгән социаль челтәр нигезендә",
  "about.rules": "Сервер кагыйдәләре",
  "account.account_note_header": "Шәхси искәрмәләр",
  "account.activity": "Активлык",
  "account.add_note": "Шәхси искәрмә өстәү",
  "account.add_or_remove_from_list": "Исемлеккә кушу яки бетерү",
  "account.badges.admin": "Админ",
  "account.badges.blocked": "Блокланган",
  "account.badges.bot": "Бот",
  "account.badges.domain_blocked": "Блокланган доменнар",
  "account.badges.group": "Төркем",
  "account.badges.muted": "Тавышсыз",
  "account.badges.muted_until": "{until}-га кадәр игнорлау",
  "account.block": "@{name} кулланучыны блоклау",
  "account.block_domain": "{domain} доменын блоклау",
  "account.block_short": "Блокла",
  "account.blocked": "Блокланган",
  "account.cancel_follow_request": "Киләсе сорау",
  "account.copy": "Профиль сылтамасын күчереп ал",
  "account.direct": "{name}-ны шәхсән икә алу",
  "account.disable_notifications": "@{name} язулары өчен белдерүләр сүндерү",
  "account.edit_note": "Шәхси искәрмәне төзәтү",
  "account.edit_profile": "Профильне үзгәртү",
  "account.edit_profile_short": "Үзгәрт",
  "account.enable_notifications": "@{name} язулары өчен белдерүләр яндыру",
  "account.endorse": "Профильдә тәкъдим итү",
  "account.featured.accounts": "Профильләр",
  "account.filters.all": "Барлык активлык",
  "account.filters.boosts_toggle": "Бустларны күрсәт",
  "account.follow": "Язылу",
  "account.followers": "Язылучы",
  "account.followers.empty": "Әле беркем дә язылмаган.",
  "account.following": "Язылулар",
  "account.follows.empty": "Беркемгә дә язылмаган әле.",
  "account.go_to_profile": "Профильгә күчү",
  "account.hide_reblogs": "Скрывать көчен нче @{name}",
  "account.in_memoriam": "Истәлегенә.",
  "account.joined_short": "Кушылды",
  "account.languages": "Сайланган телләрен үзгәртү",
  "account.link_verified_on": "Бу сылтамага милек хокукы тикшерелде {date}",
  "account.locked_info": "Бу - ябык аккаунт. Аны язылучылар гына күрә ала.",
  "account.media": "Медиа",
  "account.mention": "@{name} искәртү",
  "account.moved_to": "{name} аларның яңа счеты хәзер күрсәтте:",
  "account.mute": "@{name} кулланучыга әһәмият бирмәү",
  "account.mute_notifications_short": "Искәртүләрне сүндер",
  "account.mute_short": "Тавышсыз",
  "account.muted": "Әһәмият бирмәнгән",
  "account.open_original_page": "Чыганак битен ачу",
  "account.posts": "Язма",
  "account.report": "@{name} кулланучыга шикаять итү",
  "account.requested_follow": "{name} Сезгә язылу соравын җиберде",
  "account.share": "@{name} профиле белән уртаклашу",
  "account.show_reblogs": "Күрсәтергә көчәйтү нче @{name}",
  "account.unblock": "@{name} бикләвен чыгу",
  "account.unblock_domain": "{domain} бикләвен чыгу",
  "account.unblock_short": "Бикләүне чыгу",
  "account.unendorse": "Профильдә тәкъдим итмәү",
  "account.unfollow": "Язылуны туктату",
  "account.unmute": "Kабызыгыз @{name}",
  "account.unmute_notifications_short": "Искәртүләрне кабыз",
  "account.unmute_short": "Kабызыгыз",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.daily_retention": "Теркәлгәннән соң икенче көнне кулланучыларны тоту коэффициенты",
  "admin.dashboard.monthly_retention": "Теркәлгәннән соң ай саен кулланучыларны тоту күрсәткече",
  "admin.dashboard.retention.average": "Урта",
  "admin.dashboard.retention.cohort": "Теркәлү айлыгы",
  "admin.dashboard.retention.cohort_size": "Яңа кулланучы",
  "alert.rate_limited.message": "Зинһар, {retry_time, time, medium} соң кабатлап карагыз.",
  "alert.rate_limited.title": "Тариф чикләнгән",
  "alert.unexpected.message": "Көтелмәгән хата булды.",
  "alert.unexpected.title": "Абау!",
  "alt_text_badge.title": "Альт текст",
  "announcement.announcement": "Игълан",
  "attachments_list.unprocessed": "(чимал)",
  "audio.hide": "Аудионы яшерү",
  "block_modal.title": "Кулланучыны блокларгамы?",
  "boost_modal.combo": "Сез баса аласыз {combo} киләсе тапкыр моны сагыну өчен",
  "boost_modal.reblog": "Язманы күтәрергәме?",
  "boost_modal.undo_reblog": "Язманы күтәрмәскәме?",
  "bundle_column_error.copy_stacktrace": "Күчереп алу хата турында Отчет",
  "bundle_column_error.error.body": "Соралган бит күрсәтелә алмый. Бу безнең кодтагы хата яки браузерга туры килү проблемасы аркасында булырга мөмкин.",
  "bundle_column_error.error.title": "Әй, юк!",
  "bundle_column_error.network.body": "Бу битне йөкләргә тырышканда хата булды. Бу сезнең Интернетка тоташу яки бу сервер белән вакытлыча проблема аркасында булырга мөмкин.",
  "bundle_column_error.network.title": "Челтәр хатасы",
  "bundle_column_error.retry": "Тагын сынап кара",
  "bundle_column_error.return": "Өйгә кайтыгыз",
  "bundle_column_error.routing.body": "Сорау бите табылмады. URL адресы дөрес күрсәтелгәненә ышанасызмы?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Ябу",
  "bundle_modal_error.retry": "Тагын сынап кара",
  "closed_registrations.other_server_instructions": "Mastodon үзәкләштерелмәгәнгә, сез бүтән серверда хисап язмасы булдыра аласыз һәм аның белән аралаша аласыз.",
  "closed_registrations_modal.description": "Хисап язмасы булдыру {domain} бу хәзерге вакытта мөмкин түгел, ләкин зинһар, онытмагыз, сезгә махсус хисап кирәк түгел {domain} Мастодонны куллану өчен.",
  "closed_registrations_modal.find_another_server": "Башка серверны табыгыз",
  "closed_registrations_modal.preamble": "Mastodon үзәкләштерелмәгән, шуңа күрә сез счетыгызны кайда гына ясасагыз да, сез бу серверда теләсә кемгә иярә аласыз һәм аның белән аралаша аласыз. Сез аны хәтта үзегез урнаштыра аласыз!",
  "closed_registrations_modal.title": "Mastodon өчен теркәлү",
  "column.about": "Проект турында",
  "column.blocks": "Блокланган кулланучылар",
  "column.bookmarks": "Кыстыргычлар",
  "column.community": "Локаль вакыт сызыгы",
  "column.create_list": "Исемлек яса",
  "column.direct": "Хосусый искә алулар",
  "column.directory": "Профильләрне карау",
  "column.domain_blocks": "Блокланган доменнар",
  "column.edit_list": "Исемлекне үзгәрт",
  "column.follow_requests": "Язылу сораулары",
  "column.home": "Баш бит",
  "column.lists": "Исемлекләр",
  "column.mutes": "Тавышсыз кулланучылар",
  "column.notifications": "Искәртүләр",
  "column.pins": "Pinned toot",
  "column.public": "Глобаль вакыт сызыгы",
  "column_back_button.label": "Артка",
  "column_header.hide_settings": "Көйләүләрне яшерү",
  "column_header.moveLeft_settings": "Багананы сулга күчерегез",
  "column_header.moveRight_settings": "Багананы уңга күчерегез",
  "column_header.pin": "Беркетү",
  "column_header.show_settings": "Көйләүләрне күрсәтү",
  "column_header.unpin": "Төзәтү түгел",
  "community.column_settings.local_only": "Җирле генә",
  "community.column_settings.media_only": "Media only",
  "community.column_settings.remote_only": "Дистанцион гына идарә итү",
  "compose.language.change": "Телне үзгәртү",
  "compose.language.search": "Телләр эзләве...",
  "compose_form.direct_message_warning_learn_more": "Күбрәк белү",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "Бу язма бернинди хэштег астында да күрсәтелмәячәк, чөнки ул ачык түгел. Хэштег эзләү җәмәгать басмалары аша гына мөмкин.",
  "compose_form.lock_disclaimer": "Сезнең хисап түгел {locked}. Апуәрбер теләгән кеше сезнең язма өчен иярә ала.",
  "compose_form.lock_disclaimer.lock": "бикле",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.poll.duration": "Сораштыру озынлыгы",
  "compose_form.poll.switch_to_multiple": "Берничә вариантны чишү өчен сораштыруны Үзгәртегез",
  "compose_form.poll.switch_to_single": "Бердәнбер сайлау өчен сораштыруны Үзгәртегез",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmation_modal.cancel": "Баш тарту",
  "confirmations.block.confirm": "Блоклау",
  "confirmations.delete.confirm": "Бетерү",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete_list.confirm": "Бетерү",
  "confirmations.delete_list.message": "Сез бу исемлекне мәңгегә бетерергә телисезме?",
  "confirmations.discard_edit_media.confirm": "Баш тарту",
  "confirmations.discard_edit_media.message": "Сезнең медиа тасвирламасында яки алдан карау өчен сакланмаган үзгәрешләр бармы? ",
  "confirmations.logout.confirm": "Чыгу",
  "confirmations.logout.message": "Сез чыгарга телисезме?",
  "confirmations.mute.confirm": "Тавышсыз",
  "confirmations.redraft.confirm": "Бетерү & эшкәртү",
  "confirmations.unfollow.confirm": "Язылуны туктату",
  "conversation.delete": "Сөйләшүне бетерегез",
  "conversation.mark_as_read": "Укылганны Ничек билгеләргә",
  "conversation.open": "Сөйләшүне карау",
  "conversation.with": "{names} белән",
  "copypaste.copied": "Күчереп алынган",
  "copypaste.copy_to_clipboard": "Алмашу буферына күчереп алу",
  "directory.federated": "Билгеле галәмнән",
  "directory.local": "Кемнән {domain} гына",
  "directory.new_arrivals": "Яңа килүчеләр",
  "directory.recently_active": "Күптән түгел актив",
  "disabled_account_banner.account_settings": "Хисап көйләүләре",
  "disabled_account_banner.text": "Сезнең хисап {disabledAccount} хәзерге вакытта инвалид.",
  "dismissable_banner.community_timeline": "Бу счетлары урнаштырылган кешеләрдән иң соңгы җәмәгать хәбәрләре {domain}.",
  "dismissable_banner.dismiss": "Ябу",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "Менә ул нинди булыр:",
  "emoji_button.activity": "Активлык",
  "emoji_button.clear": "Чистарту",
  "emoji_button.custom": "Куелган",
  "emoji_button.flags": "Байраклар",
  "emoji_button.food": "Ашау һәм эчү",
  "emoji_button.label": "Эмодзи кертү",
  "emoji_button.nature": "Табигать",
  "emoji_button.not_found": "Дөрес эможалар табылмады",
  "emoji_button.objects": "Объектлар",
  "emoji_button.people": "Кешеләр",
  "emoji_button.recent": "Еш кулланыла",
  "emoji_button.search": "Эзләү...",
  "emoji_button.search_results": "Эзләү нәтиҗәләре",
  "emoji_button.symbols": "Символлар",
  "emoji_button.travel": "Сәяхәт һәм урыннар",
  "empty_column.account_suspended": "Аккаунт блокланган",
  "empty_column.account_timeline": "Монда язмалар юк!",
  "empty_column.account_unavailable": "Профиль кулланып булмады",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "errors.unexpected_crash.report_issue": "Хата турында белдерү",
  "explore.suggested_follows": "Кешеләр",
  "explore.trending_links": "Яңалыклар",
  "explore.trending_statuses": "Язмалар",
  "explore.trending_tags": "Хәштәгләр",
  "filter_modal.added.review_and_configure_title": "Сөзгеч көйләүләре",
  "filter_modal.added.settings_link": "көйләүләр бите",
  "filter_modal.added.title": "Сөзгеч өстәлде!",
  "filter_modal.select_filter.expired": "вакыты чыкты",
  "filter_modal.select_filter.prompt_new": "Яңа категория: {name}",
  "filter_modal.select_filter.search": "Эзләү яки ясау",
  "filter_modal.select_filter.title": "Бу язманы фильтрлау",
  "filter_modal.title.status": "Бер язманы фильтрлау",
  "follow_request.authorize": "Авторизация",
  "follow_request.reject": "Кире кагу",
  "followed_tags": "Имзаланган хэштеглар",
  "footer.about": "Проект турында",
  "footer.directory": "Профильләр каталогы",
  "footer.get_app": "Кушымта алыгыз",
  "footer.keyboard_shortcuts": "Төймә комбинацияләре",
  "footer.privacy_policy": "Хосусыйлык сәясәте",
  "footer.source_code": "Чыганак кодын карау",
  "footer.status": "Халәт",
  "generic.saved": "Сакланды",
  "getting_started.heading": "Башлау",
  "hashtag.column_header.tag_mode.all": "һәм {additional}",
  "hashtag.column_header.tag_mode.any": "яки {additional}",
  "hashtag.column_header.tag_mode.none": "гайре {additional}",
  "hashtag.column_settings.select.no_options_message": "Тәкъдимнәр табылмады",
  "hashtag.column_settings.select.placeholder": "Хэштегларны кертегез…",
  "hashtag.column_settings.tag_mode.all": "Боларның барысы",
  "hashtag.column_settings.tag_mode.any": "Һәрберсе",
  "hashtag.column_settings.tag_mode.none": "Аларның берсе дә",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "Хэштегка язылу",
  "hashtag.unfollow": "Хэштегка язылу юк",
  "home.column_settings.show_reblogs": "Табышмаклау",
  "home.column_settings.show_replies": "Җаваплар күрсәтү",
  "home.hide_announcements": "Игъланнарны яшерү",
  "home.show_announcements": "Белдерүләр бирегез",
  "interaction_modal.on_another_server": "Башка серверда",
  "interaction_modal.on_this_server": "Бу серверда",
  "intervals.full.days": "{number, plural, one {# көн} other {# көн}}",
  "intervals.full.hours": "{number, plural, one {# сәгать} other {# сәгать}}",
  "intervals.full.minutes": "{number, plural, one {# минут} other {# минут}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Тасвирлама",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "Кайнар Ачкыч",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "Ябу",
  "lightbox.next": "Киләсе",
  "lightbox.previous": "Алдагы",
  "limited_account_hint.action": "Барыбер профильне күрсәтергә",
  "limited_account_hint.title": "Бу профильне модераторлар яшергән {domain}.",
  "lists.delete": "Исемлекне бетерегез",
  "lists.edit": "Исемлекне үзгәртү",
  "lists.replies_policy.list": "Исемлек әгъзалары",
  "lists.replies_policy.none": "Һичкем",
  "load_pending": "{count, plural, one {# яңа элемент} other {# яңа элемент}}",
  "navigation_bar.about": "Проект турында",
  "navigation_bar.blocks": "Блокланган кулланучылар",
  "navigation_bar.bookmarks": "Кыстыргычлар",
  "navigation_bar.direct": "Хосусый искә алулар",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.lists": "Исемлекләр",
  "navigation_bar.logout": "Чыгу",
  "navigation_bar.preferences": "Caylaw",
  "navigation_bar.search": "Эзләү",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.clear": "Искәртүләрне чистарту",
  "notifications.column_settings.admin.report": "Яңа шикаятьләр:",
  "notifications.column_settings.mention": "Искә алулар:",
  "notifications.column_settings.push": "Push-искәртүләр",
  "notifications.column_settings.sound": "Тавышны уйнату",
  "notifications.column_settings.status": "New toots:",
  "notifications.column_settings.update": "Төзәтүләр:",
  "notifications.filter.all": "Бөтенесе",
  "notifications.filter.mentions": "Искә алулар",
  "notifications.filter.polls": "Сораштыру нәтиҗәләре",
  "notifications.grant_permission": "Керү мөмкинлеген бирү.",
  "notifications.group": "{count} искәртү",
  "notifications_permission_banner.enable": "Эш өстәле искәртүләрен кабызу",
  "notifications_permission_banner.title": "Әйберне мәңге югалтмаска",
  "picture_in_picture.restore": "Кире кайтару",
  "poll.closed": "Ябык",
  "poll.refresh": "Яңарту",
  "poll.total_people": "{count, plural, one {# кеше} other {# кеше}}",
  "poll.total_votes": "{count, plural, one {# тавыш} other {# тавыш}}",
  "poll.vote": "Тавыш бирү",
  "poll.votes": "{votes, plural, one {# тавыш} other {# тавыш}}",
  "poll_button.add_poll": "Сораштыруны өстәү",
  "poll_button.remove_poll": "Сораштыруны бетерү",
  "privacy.change": "Adjust status privacy",
  "privacy.public.short": "Һәркемгә ачык",
  "privacy_policy.last_updated": "Соңгы яңарту {date}",
  "privacy_policy.title": "Хосусыйлык Сәясәте",
  "refresh": "Яңарту",
  "relative_time.days": "{number}к",
  "relative_time.full.days": "{number, plural, one {# көн} other {# көн}} элек",
  "relative_time.full.hours": "{number, plural, one {# сәгать} other {# сәгать}} элек",
  "relative_time.full.just_now": "хәзер",
  "relative_time.full.minutes": "{number, plural, one {# минут} other {# минут}} элек",
  "relative_time.full.seconds": "{number, plural, one {# секунд} other {# секунд}} элек",
  "relative_time.hours": "{number}с",
  "relative_time.just_now": "хәзер",
  "relative_time.minutes": "{number}м",
  "relative_time.seconds": "{number}сек",
  "relative_time.today": "бүген",
  "reply_indicator.cancel": "Баш тарту",
  "report.block": "Блоклау",
  "report.categories.other": "Башка",
  "report.categories.spam": "Спам",
  "report.category.title_account": "профиль",
  "report.category.title_status": "язма",
  "report.close": "Булды",
  "report.forward": "{target}-га тапшыру",
  "report.mute": "Тавышны ябу",
  "report.next": "Киләсе",
  "report.placeholder": "Type or paste additional comments",
  "report.reasons.dislike": "Миңа бу ошамый",
  "report.reasons.other": "Башка нәрсә",
  "report.reasons.spam": "Бу спам",
  "report.rules.subtitle": "Кулланганнарның барысын да сайлагыз",
  "report.statuses.subtitle": "Кулланганнарның барысын да сайлагыз",
  "report.submit": "Җибәрү",
  "report.target": "Report {target}",
  "report.thanks.title": "Моны күрергә теләмисезме?",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.other": "Башка",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.violation": "Кагыйдә бозыла",
  "report_notification.open": "Шикаятьне ачу",
  "search.no_recent_searches": "Соңгы эзләнүләр юк",
  "search.placeholder": "Эзләү",
  "search.quick_action.go_to_account": "Профильгә күчү {x}",
  "search_popout.quick_actions": "Тиз гамәлләр",
  "search_popout.recent": "Соңгы эзләнүләр",
  "search_results.accounts": "Профильләр",
  "search_results.all": "Барысы да",
  "search_results.hashtags": "Хәштәгләр",
  "search_results.statuses": "Язмалар",
  "server_banner.administered_by": "Идарә итүче:",
  "server_banner.server_stats": "Сервер статистикасы:",
  "sign_in_banner.create_account": "Аккаунтны ясау",
  "sign_in_banner.sign_in": "Керү",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "@{name} блоклау",
  "status.bookmark": "Кыстыргычларга саклау",
  "status.copy": "Copy link to status",
  "status.delete": "Бетерү",
  "status.direct_indicator": "Хосусый искә алу",
  "status.edit": "Үзгәртү",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.history.created": "{name} ясалды {date}",
  "status.history.edited": "{name} төзәтте {date}",
  "status.load_more": "Күбрәк йөкләү",
  "status.media_hidden": "Яшергән медиа-файл",
  "status.mention": "@{name} Искә алу",
  "status.more": "Күбрәк",
  "status.open": "Expand this status",
  "status.read_more": "Күбрәк уку",
  "status.reblog": "Уртаклашу",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.reply": "Җавап бирү",
  "status.share": "Уртаклашу",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Тәрҗемә итү",
  "subscribed_languages.save": "Үзгәрешләрне саклау",
  "tabs_bar.home": "Баш бит",
  "tabs_bar.notifications": "Белдерүләр",
  "time_remaining.days": "{number, plural, one {# көн} other {# көн}} калды",
  "time_remaining.hours": "{number, plural, one {# сәгать} other {# сәгать}} калды",
  "time_remaining.minutes": "{number, plural, one {# минут} other {# минут}} калды",
  "time_remaining.seconds": "{number, plural, one {# секунд} other {# секунд}} калды",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "units.short.billion": "{count} млрд",
  "units.short.million": "{count} млн",
  "units.short.thousand": "{count} мең",
  "upload_form.edit": "Үзгәртү",
  "upload_progress.label": "Йөкләү...",
  "upload_progress.processing": "Эшкәртелә…",
  "video.close": "Видеоны ябу",
  "video.download": "Файлны йөкләү",
  "video.exit_fullscreen": "Тулы экран режимыннан чыгу",
  "video.expand": "Видеоны җәю",
  "video.fullscreen": "Тулы экран",
  "video.hide": "Видеоны яшерү",
  "video.pause": "Туктату",
  "video.play": "Уйнату"
}
